import { createSlice } from '@reduxjs/toolkit';

import { submitImageSearch } from '@/redux/modules/search/imageSearch/imageSearch.actions';
import { defaultImageSearchSlice } from '@/redux/modules/search/imageSearch/imageSearch.types';

const imageSearchSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(submitImageSearch.pending, (slice) => {
            // Keep the prior results/thumbnail on screen while the new search runs — the results
            // page renders from this slice, so clearing here blanks a re-search started from it.
            slice.status = 'analysing';
            slice.error = null;
        });
        builder.addCase(submitImageSearch.fulfilled, (slice, { payload }) => {
            slice.status = 'success';
            slice.error = null;
            slice.results = payload.results;
            slice.thumbnailUrl = payload.thumbnailUrl;
        });
        builder.addCase(submitImageSearch.rejected, (slice, { payload }) => {
            // Preserve the prior results/thumbnail so a failed re-search keeps the last successful
            // results visible and surfaces the error in the popover, not a false "no match found".
            slice.status = 'error';
            slice.error = payload ?? 'request-failed';
        });
    },
    initialState: defaultImageSearchSlice,
    name: 'imageSearch',
    // Object-URL revocation lives in useImageSearch (component layer) so this reducer stays pure.
    reducers: {
        clearImageSearchError: (slice) => {
            // Drop a stale error without discarding results: reopening the upload surface lands on a
            // clean dropzone while any results already on the page stay put (and don't redirect home).
            slice.error = null;
            slice.status = slice.results.length > 0 ? 'success' : 'idle';
        },
    },
});

export const { clearImageSearchError } = imageSearchSlice.actions;
export const { reducer: imageSearchReducer } = imageSearchSlice;
